module.exports = __webpack_public_path__ + "img/Slice5.0577d793.png";